<script>
  import TextInput from '../../../../components/inputs/text';
  import NumberInput from '../../../../components/inputs/num';
  import MinAgeInput from '../../../../components/inputs/minage';
  import TextAreaInput from '../../../../components/inputs/textarea';
  import Form from '../../../../components/inputs/form';

  export let value;
  export let readonly = false;
</script>

<div>
  <Form>
    <div class="form-group">
      <NumberInput
        type="number"
        bind:value="{value.constraints.capacity}"
        label="Capacity"
        placeholder="Capacity"
        readonly="{readonly}"
      ></NumberInput>
    </div>

    <div class="form-group">
      <MinAgeInput
        bind:value="{value.constraints.minAge}"
        label="Minimum Age"
        placeholder="Minimum Age"
        readonly="{readonly}"
      ></MinAgeInput>
    </div>

    <div class="form-group">
      <NumberInput
        type="number"
        bind:value="{value.constraints.staff}"
        label="Support Staff"
        placeholder="Support Staff"
        readonly="{readonly}"
      ></NumberInput>
    </div>

    <div class="form-group">
      <TextInput
        bind:value="{value.monthlyBudget}"
        label="Monthly Budget"
        placeholder="Monthly Budget"
        readonly="{readonly}"
      ></TextInput>
    </div>

    <div class="form-group">
      <TextAreaInput
        bind:value="{value.notes}"
        label="Internal Notes"
        placeholder="Internal Notes"
        readonly="{readonly}"
      ></TextAreaInput>
    </div>
  </Form>
</div>
